const materialReducer = (state = null, action) => {
  switch (action.type) {
    case 'MATERIAL_POPUP_SET': return action.payload;
    case 'MATERIAL_POPUP_CLOSE': return null;
    default: return state;
  }
};

export default materialReducer;
